import { useSite } from "../../context/SiteContext";

const FALLBACK = ["SPORT", "CREATIVITY", "TALENT", "OPPORTUNITY", "BRANDS", "CULTURE", "CLUBS", "COMMUNITIES", "IDEAS", "IMPACT", "STRATEGY", "EMOTION", "BUSINESS"];

function Row({ words, reverse = false, outline = false, duration = "55s" }) {
    const doubled = [...words, ...words];
    return (
        <div className="overflow-hidden whitespace-nowrap">
            <div className={`marquee-track items-center ${reverse ? "marquee-reverse" : ""}`} style={{ "--marquee-duration": duration }}>
                {doubled.map((w, i) => (
                    <span key={i} className="mx-5 inline-flex items-center gap-10 md:mx-8">
                        <span className={`font-display text-[16vw] leading-[0.9] md:text-[7.5vw] ${outline ? "text-outline-w" : "text-white"}`}>{w}</span>
                        <span className="font-display text-[8vw] leading-none text-[#D60024] md:text-[4vw]" aria-hidden="true">+</span>
                    </span>
                ))}
            </div>
        </div>
    );
}

export default function PlusConnects() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const words = c.connects_words?.length ? c.connects_words : FALLBACK;
    const half = Math.ceil(words.length / 2);

    return (
        <section id="connects" data-testid="connects-section" className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-20 md:py-28">
            <p className="mb-10 px-6 text-center text-[11px] font-semibold uppercase tracking-[0.35em] text-[#D60024] md:px-12" data-testid="connects-title">
                {tx(c.connects_title) || "THE + CONNECTS"}
            </p>
            <Row words={words.slice(0, half)} duration="60s" />
            <div className="h-6 md:h-10" />
            <Row words={words.slice(half)} reverse outline duration="70s" />
        </section>
    );
}
